import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { authAPI } from '../utils/api';
import './EmailConfirmation.css';

const EmailConfirmation = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('loading'); // loading, success, error
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (token) {
      verifyEmail(token);
    } else {
      setStatus('error');
      setMessage('Ungültiger Bestätigungslink. Das Token fehlt.');
    }
  }, [token]);

  const verifyEmail = async (verificationToken) => {
    try {
      const res = await authAPI.verifyEmail(verificationToken);
      if (res.success) {
        setStatus('success');
        // Solange der Vorstand nicht freigeschaltet hat, waere "jetzt anmelden"
        // eine falsche Aufforderung.
        setMessage(res.needsApproval
          ? 'Deine E-Mail-Adresse ist bestätigt. Dein Konto wird jetzt vom Vorstand freigeschaltet – du bekommst eine E-Mail, sobald du dich anmelden kannst.'
          : (res.message || 'Ihre E-Mail-Adresse wurde erfolgreich bestätigt!'));
        toast.success('E-Mail-Adresse bestätigt!');
        setTimeout(() => navigate('/login'), 3000);
      } else {
        setStatus('error');
        setMessage(res.error || 'Der Bestätigungslink ist ungültig oder abgelaufen.');
        toast.error('Bestätigung fehlgeschlagen');
      }
    } catch (error) {
      setStatus('error');
      setMessage(error.response?.data?.error || 'Der Bestätigungslink ist ungültig oder abgelaufen.');
      toast.error('Fehler bei der E-Mail-Bestätigung');
    }
  };

  const resendConfirmation = () => {
    // Simuliere das erneute Senden der Bestätigungs-E-Mail
    toast.success('Eine neue Bestätigungs-E-Mail wurde gesendet!');
  };

  return (
    <div className="email-confirmation">
      <div className="container">
        <div className="confirmation-card">
          <div className="confirmation-icon">
            {status === 'loading' && (
              <div className="loading-spinner">
                <div className="spinner"></div>
              </div>
            )}
            {status === 'success' && (
              <div className="success-icon">✓</div>
            )}
            {status === 'error' && (
              <div className="error-icon">✕</div>
            )}
          </div>

          <div className="confirmation-content">
            <h1>E-Mail-Bestätigung</h1>

            {status === 'loading' && (
              <div>
                <p>Ihre E-Mail-Adresse wird bestätigt...</p>
                <div className="loading-text">
                  Bitte warten Sie einen Moment.
                </div>
              </div>
            )}

            {status === 'success' && (
              <div className="success-content">
                <h2>Bestätigung erfolgreich!</h2>
                <p>{message}</p>
                <p>Sie können sich jetzt mit Ihren Anmeldedaten einloggen.</p>
                <div className="redirect-info">
                  Sie werden automatisch zur Anmeldung weitergeleitet...
                </div>
                <div className="confirmation-actions">
                  <button
                    onClick={() => navigate('/login')}
                    className="btn btn-primary"
                  >
                    Jetzt anmelden
                  </button>
                  <button
                    onClick={() => navigate('/')}
                    className="btn btn-secondary"
                  >
                    Zur Startseite
                  </button>
                </div>
              </div>
            )}

            {status === 'error' && (
              <div className="error-content">
                <h2>Bestätigung fehlgeschlagen</h2>
                <p>{message}</p>
                <div className="error-help">
                  <h3>Was können Sie tun?</h3>
                  <ul>
                    <li>Überprüfen Sie, ob Sie den vollständigen Link aus der E-Mail verwendet haben</li>
                    <li>Der Link ist möglicherweise abgelaufen (gültig für 24 Stunden)</li>
                    <li>Fordern Sie eine neue Bestätigungs-E-Mail an</li>
                  </ul>
                </div>
                <div className="confirmation-actions">
                  <button
                    onClick={resendConfirmation}
                    className="btn btn-primary"
                  >
                    Neue Bestätigungs-E-Mail senden
                  </button>
                  <button
                    onClick={() => navigate('/registrieren')}
                    className="btn btn-secondary"
                  >
                    Neue Registrierung
                  </button>
                  <button
                    onClick={() => navigate('/')}
                    className="btn btn-secondary"
                  >
                    Zur Startseite
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>

        <div className="help-section">
          <h3>Benötigen Sie Hilfe?</h3>
          <p>
            Falls Sie Probleme bei der E-Mail-Bestätigung haben, kontaktieren Sie uns unter:
          </p>
          <div className="contact-info">
            <p><strong>E-Mail:</strong> support@efc-buseck.de</p>
            <p><strong>Telefon:</strong> 0152 08833485</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmailConfirmation;
